module.exports = __webpack_public_path__ + "img/myDataBg.8f678048.png";